export const getSearchIndicesArray = (sourceWithIndicesMap: Map<string, string[]>) => {
    return Array.from(sourceWithIndicesMap.values()).flat();
}

export const getConnectedSearchIndicesForSearch = (sourceWithIndicesMap: Map<string, string[]>) => {
    return getSearchIndicesArray(sourceWithIndicesMap).join(",")
}

export const getSourceNameByIndex = (index: string, sourceNameWithIndicesMap: Map<string, string[]>) => {
    for (const [sourceName, indices] of sourceNameWithIndicesMap.entries()) {
        if (indices.includes(index)) {
            return sourceName;
        }
    }
    return "E.ON General Knowledge";
}